import { Dialog, DialogContent } from "@mui/material"
import { CadastrarEditarProgramaFidelidade } from "../CadastrarEditarProgramaFidelidade";
import { FieldValues } from "react-hook-form";

interface CadastrarEditarProgramaFidelidadeModalProps {
    handleCancelar: () => void;
    handleCadastrarPrograma: (programa: FieldValues) => void;
    open: boolean;
    loading: boolean;
}

export const CadastrarEditarProgramaFidelidadeModal = ({ 
    open, 
    handleCancelar, 
    handleCadastrarPrograma, 
    loading 
}: CadastrarEditarProgramaFidelidadeModalProps) => {
    return (
        <Dialog 
            open={open} 
            onClose={handleCancelar} 
            maxWidth="sm" 
            fullWidth={false}
            PaperProps={{
                sx: {
                    width: '500px',
                    maxHeight: '80vh'
                }
            }}
        >
            <DialogContent sx={{ 
                overflowY: 'auto',
                padding: '1.5rem'
            }}>
                <CadastrarEditarProgramaFidelidade
                    cadastrar={handleCadastrarPrograma}
                    cancelar={handleCancelar}
                    loading={loading}
                />
            </DialogContent>
        </Dialog>
    )
}

